import { Box, Typography } from "@material-ui/core";
import React, { CSSProperties } from "react";

interface ItemProps {
  title: string;
  children: React.ReactNode;
  style?: CSSProperties;
}

export const Item = ({ title, children, style }: ItemProps) => (
  <Box
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="start"
    style={style}
  >
    <Typography variant="body1" style={{ fontWeight: "bold" }}>
      {title}
    </Typography>
    {children}
  </Box>
);